'use strict';

angular.module('adminDefaultEntitlementControllers')

.controller('AddDefaultEntitlementController', ['$scope', '$state', '$stateParams', '$controller', 'businessSystemService', 'searchService', 'adminDefaultEntitlementService', function ($scope, $state, $stateParams, $controller, businessSystemService, searchService, adminDefaultEntitlementService) {

    $controller('BaseFeatureController', {
        $scope: $scope, $state: $state, $stateParams: $stateParams, businessSystemService: businessSystemService
    });

    $scope.$watch('keywordsSearchSupervisor', function (newKeywords, oldKeywords) {
        if (newKeywords !== oldKeywords) {
            if (_.isEmpty(newKeywords)) $scope.clearSearch();
            else $scope.searchSupervisors();
        }
    });

    $scope.searchSupervisors = function () {
        searchService.searchSupervisors($scope.keywordsSearchSupervisor)
                     .then(function (hits) {
                         $scope.supervisors = hits;
                     });
    }

    $scope.addDefaultEntitlement = function(supervisor) {
        adminDefaultEntitlementService.addDefaultEntitlement($scope.systemRoleId, supervisor.EmployeeID)
            .then(function(entitlement) {
                $state.go('adminDefaultEntitlement.bySystemRole.viewExistingRights', {
                    systemId: $scope.systemId,
                    systemRoleId: $scope.systemRoleId
                });
        });
    }

    $scope.clearSearch = function () {
        $scope.keywordsSearchSupervisor = null;
        $scope.supervisors = [];
    }

    $scope.clearSearch();
}]);
